import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import TelegramIconLink from "./TelegramIconLink";

const Footer: React.FC = () => {
  const { t } = useTranslation();

  // Load iubenda script for privacy and cookie policy links
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://cdn.iubenda.com/iubenda.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div
      className="fixed bottom-0 left-0 right-0 shadow-[0_-4px_20px_rgba(0,0,0,0.1)] z-[999] px-2 sm:px-4 py-2 sm:py-3"
      style={{
        paddingBottom: "max(env(safe-area-inset-bottom), 8px)",
        borderTop: "1px solid #5A18C44D",
        fontFamily: "'Fragment Mono', monospace",
        background:
          "linear-gradient(90deg, #2F0D68 0%, #240D49 50%, #2F0D68 100%)",
      }}
    >
      <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-0 max-w-screen-2xl mx-auto">
        {/* Left: Policy Links - nascosti su mobile piccolo */}
        <div className="hidden md:flex items-center gap-2 ml-8 sm:gap-4 text-xs sm:text-sm uppercase font-medium">
          <a
            href="https://www.iubenda.com/privacy-policy/92659911"
            className="text-white hover:text-white/80 transition-colors whitespace-nowrap"
            title="Privacy Policy"
            style={{
              textDecoration: "underline",
              letterSpacing: "-0.05em",
              background: "transparent !important",
              border: "none !important",
              padding: "0 !important",
            }}
          >
            Privacy Policy
          </a>
          <a
            href="https://www.iubenda.com/privacy-policy/92659911/cookie-policy"
            className="text-white hover:text-white/80 transition-colors whitespace-nowrap"
            title="Cookie Policy"
            style={{
              textDecoration: "underline",
              letterSpacing: "-0.05em",
              background: "transparent !important",
              border: "none !important",
              padding: "0 !important",
            }}
          >
            Cookie Policy
          </a>
        </div>

        {/* Right: Telegram Icon */}
        <div className="hidden md:block">
          <TelegramIconLink
            href="https://t.me/+dbQrqOeo0Q9hM2Qy"
            title={t("footer.telegram", "Telegram")}
          />
        </div>

        {/* Policy Links per mobile - sotto */}
        <div className="flex md:hidden items-center gap-3 text-[10px] uppercase font-medium">
          <a
            href="https://www.iubenda.com/privacy-policy/92659911"
            className="text-white hover:text-primary-600 transition-colors whitespace-nowrap"
            title="Privacy Policy"
            style={{
              textDecoration: "underline",
              letterSpacing: "-0.05em",
              background: "transparent !important",
              border: "none !important",
              padding: "0 !important",
            }}
          >
            Privacy
          </a>
          <span className="text-gray-400">•</span>
          <a
            href="https://www.iubenda.com/privacy-policy/92659911/cookie-policy"
            className="text-white hover:text-primary-600 transition-colors whitespace-nowrap"
            title="Cookie Policy"
            style={{
              textDecoration: "underline",
              letterSpacing: "-0.05em",
              background: "transparent !important",
              border: "none !important",
              padding: "0 !important",
            }}
          >
            Cookie
          </a>
          <span className="text-gray-400">•</span>
          <a
            href="https://t.me/+dbQrqOeo0Q9hM2Qy"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-primary-600 transition-colors whitespace-nowrap"
            title="Telegram"
            style={{
              textDecoration: "underline",
              letterSpacing: "-0.05em",
            }}
          >
            Telegram
          </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
